// client/src/context/SoundContext.jsx
import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import useSound from 'use-sound';

const SoundContext = createContext(null);

export const SoundProvider = ({ children }) => {
  const [isMuted, setIsMuted] = useState(false);
  
  // المؤثرات الصوتية الحالية
  const [playGoal] = useSound('/sounds/goal.mp3', { volume: 0.7 });
  const [playWhistle] = useSound('/sounds/whistle.mp3', { volume: 0.6 });
  const [playRed] = useSound('/sounds/red.mp3', { volume: 0.6 });
  const [playCheer, { stop: stopCheer }] = useSound('/sounds/cheer.mp3', { loop: true, volume: 0.3 });
  
  // 🔥 NEW: Ambulance sound effect
  const [playAmbulance] = useSound('/sounds/ambulance.mp3', { volume: 0.7 });

  // دالة بدء المشجعين (تبدأ مرة واحدة عند بداية المباراة)
  const startCheer = () => {
    playCheer();
  };

  const stopCheerSound = () => {
    stopCheer();
  };

  const value = {
    playGoal,
    playWhistle,
    playRed,
    playAmbulance, // 🔥 NEW
    startCheer,
    stopCheerSound,
    isMuted,
    setIsMuted,
  };

  return <SoundContext.Provider value={value}>{children}</SoundContext.Provider>;
};

export const useSoundEffects = () => {
  const context = useContext(SoundContext);
  if (!context) {
    throw new Error('useSoundEffects must be used within SoundProvider');
  }
  return context;
};